import { getBoggleBadgePointsForLevel, type BoggleBadgeDefinition } from '../types'

export const masterBadgeDefinition: BoggleBadgeDefinition = {
  category: 'mastery',
  description: 'Finish a run with an average length of 4.5+ (40+ words)',
  iconId: 'master',
  id: 'master',
  level: 'legendary',
  lockedReveal: 'mystery',
  name: 'Master',
  points: getBoggleBadgePointsForLevel('legendary'),
}
